import { render, staticRenderFns } from "./broadcast-points.vue?vue&type=template&id=5ebd5640&scoped=true"
import script from "./broadcast-points.vue?vue&type=script&lang=js"
export * from "./broadcast-points.vue?vue&type=script&lang=js"
import style0 from "./broadcast-points.vue?vue&type=style&index=0&id=5ebd5640&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebd5640",
  null
  
)

export default component.exports